import { Avatar, styled } from '@mui/material';

import {
  type ResourceTimelineSeparatorProps,
  useResourceTimelineSeparator,
} from './useResourceTimelineSeparator';

type Props = ResourceTimelineSeparatorProps;

const StyledTimelineSeparator = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  minWidth: 32,
  flex: 0,
});

const TimelineNodeAvatar = styled(Avatar, {
  shouldForwardProp: (prop) => prop !== 'bgColor' && prop !== 'textColor',
})<{ bgColor: string; textColor: string }>(({ bgColor, textColor }) => ({
  width: 32,
  height: 32,
  backgroundColor: bgColor,
  color: textColor,
  flexShrink: 0,
}));

const TopDashedTimelineConnector = styled('span')(({ theme }) => ({
  width: 0,
  height: 12,
  minHeight: 12,
  flexShrink: 0,
  flexGrow: 0,
  borderLeft: `2px dashed ${theme.palette.divider}`,
  backgroundColor: 'transparent',
}));

const BottomDashedTimelineConnector = styled('span')(({ theme }) => ({
  width: 0,
  flexGrow: 1,
  borderLeft: `2px dashed ${theme.palette.divider}`,
  backgroundColor: 'transparent',
  minHeight: 12,
}));

export function ResourceTimelineSeparator(props: Props) {
  const hook = useResourceTimelineSeparator(props);
  const IconComponent = hook.IconComponent;

  return (
    <StyledTimelineSeparator
      data-testid={props['data-testid'] ?? 'resource-timeline-separator'}
    >
      <TopDashedTimelineConnector />
      <TimelineNodeAvatar bgColor={hook.meta.bgColor} textColor={hook.meta.textColor}>
        <IconComponent fontSize="small" />
      </TimelineNodeAvatar>
      <BottomDashedTimelineConnector />
    </StyledTimelineSeparator>
  );
}

export type { Props as ResourceTimelineSeparatorProps };
